module.exports = __webpack_public_path__ + "static/img/line.c343a4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/line.png
// module id = eRT6
// module chunks = 1